<template>
  <div class="set-commission" ref="setCommissionRef">
    <artmisads-modal
      v-model:open="props.showSetCommission"
      :title="modalTitle"
      :width="800"
      :ok-text="$t('seller.common.confirm')"
      :onCancel="onCancel"
      :getContainer="() => setCommissionRef"
      :destroyOnClose="true"
      :maskClosable="false"
    >
      <div class="top" v-if="props.type == 'brand'">
        <div class="top-left">
          <div
            class="brand-img-show"
            :style="
              props.item?.logoImageUrl
                ? { background: 'rgba(238, 237, 242, 1)' }
                : ''
            "
          >
            <img
              :src="props.item?.logoImageUrl"
              v-if="props.item?.logoImageUrl"
            />
            <span class="brand-name" v-else>{{
              props.item?.amazonBrandName
            }}</span>
          </div>
        </div>
        <div class="top-right">
          <div class="top-right-title">
            {{ props.item?.amazonBrandName }}
          </div>
          <div class="top-right-content">
            <div class="top-right-status">
              <div class="top-right-status-title">{{ $t('seller.common.status') }}</div>
              <Status
                :type="props.item?.status?.toLowerCase()"
                :noBorder="true"
                :text="props.item?.status == 'active' ? $t('seller.common.active') : $t('seller.common.inactive')"
                style="margin-top: 4px"
              />
              <!-- <Status :type="props.item.associateStatus.toLowerCase()" v-if="configs.activeTab == '1'" :noBorder="true"
                    :text="props.item.associateStatus == 'active' ? 'Active' : 'Inactive'
                      " style="margin-top: 4px" /> -->
            </div>
            <div class="top-right-mid"></div>
            <div class="top-right-products">
              <div class="top-right-status-title">{{ $t('seller.brandsPage.productsLabel') }}</div>
              <div class="top-right-status-count">
                <!-- {{
                      configs.activeTab == '0'
                        ? props.item.activeProductCount
                        : props.item.associateActiveProductCount
                    }} -->
                {{ props.item?.activeProductCount }}
                <a-popover placement="bottom">
                  <template #title>
                    <div class="pop-title">
                      {{ $t('seller.setPublicCommission.bulkPopoverBefore') }}<span
                        style="color: rgba(138, 100, 244, 1); font-weight: 700"
                      >
                        {{ props.item?.activeProductCount }}
                      </span
                      >{{ $t('seller.setPublicCommission.bulkPopoverAfter') }}
                    </div>
                  </template>
                  <Icon name="wenhao-tianchong" class="wenhao" />
                </a-popover>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="top"
        v-if="props.type == 'product' && item?.type == 'single'"
      >
        <div class="top-left">
          <div
            class="brand-img-show"
            :style="
              item?.imageUrl ? { background: 'rgba(238, 237, 242, 1)' } : ''
            "
          >
            <img :src="item?.imageUrl" v-if="item?.imageUrl" />
            <span class="brand-name" v-else>{{ item?.title }}</span>
          </div>
        </div>
        <div class="top-right">
          <div class="top-right-title">
            {{ item?.title }}
          </div>
          <div class="top-right-content">
            <div class="top-right-status">
              <div class="top-right-status-title">{{ $t('seller.common.status') }}</div>
              <Status
                :type="item?.status?.toLowerCase()"
                :noBorder="true"
                :text="item?.status == 'active' ? $t('seller.common.active') : $t('seller.common.inactive')"
                style="margin-top: 4px"
              />
            </div>
            <div class="top-right-mid"></div>
            <div class="top-right-products">
              <div class="top-right-status-title">{{ $t('seller.setPublicCommission.labelAsin') }}</div>
              <a-popover placement="top">
                <template #content>
                  {{ item?.asin }}
                </template>

                <div class="top-right-status-count">
                  {{ item?.asin }}
                </div>
              </a-popover>
            </div>
            <div class="top-right-mid"></div>
            <div class="top-right-products">
              <div class="top-right-status-title">{{ $t('seller.setPublicCommission.labelBrand') }}</div>
              <a-popover placement="top">
                <template #content>
                  {{ item?.brandName }}
                </template>

                <div class="top-right-status-count">
                  {{ item?.brandName }}
                </div>
              </a-popover>
            </div>
            <div class="top-right-mid"></div>
            <div class="top-right-products">
              <div class="top-right-status-title">{{ $t('seller.setPublicCommission.labelPrice') }}</div>
              <a-popover placement="top">
                <template #content>
                  {{ item?.currencySymbol }} {{ item?.price }}
                </template>

                <div class="top-right-status-count">
                  {{ item?.currencySymbol }} {{ item?.price }}
                </div>
              </a-popover>
            </div>
          </div>
        </div>
      </div>
      <div class="topMulti" v-if="item?.type != 'single'&&type=='product'">
        {{
          $t('seller.setPublicCommission.selectedProductsCount', {
            count: props.selectedRowKeys.length,
          })
        }}
      </div>
      <div class="set-commission-wrap">
        <p
          class="first-p"
          v-if="props.type != 'brand' && props.type != 'product'"
        >
          {{ $t('seller.setPublicCommission.introPublicCommission') }}
        </p>
        <div class="content">
          <div class="title">{{ $t('seller.setPublicCommission.sectionSetCommission') }}</div>
          <div class="commission">
            <div class="commission-input">
              <span>{{ $t('seller.brandsPage.publisherCommission') }}</span>
              <artmisads-input-number
                :min="0"
                :max="100"
                suffix="%"
                :step="0.5"
                size="large"
                @blur="commissionBlur"
                v-model:value="commission"
                @change="handleChangeCommission($event)"
              />
              <!-- <span v-if="showDefalutText" class="defalut-text" @click="clickDefalutText">Please enter...</span> -->
            </div>
            <span>+</span>
            <div class="fees">
              <span
                >{{ $t('seller.brandsPage.artemisAdsFees') }}<a-tooltip
                  :getPopupContainer="() => $refs.setCommissionRef"
                >
                  <template #title>
                    {{ feesTooltipText }}
                  </template>
                  <Icon
                    name="wenhao-tianchong"
                    class="question-icon"
                  /> </a-tooltip
              ></span>
              <artmisads-button disabled
                >{{ fees?.toFixed(1) }}%</artmisads-button
              >
            </div>
            <span>=</span>
            <div class="total">
              <span>{{ $t('seller.brandsPage.totalLabel') }}</span>
              <artmisads-button disabled>
                <span>{{
                  commission
                    ? parseFloat(Number(fees) + Number(commission)).toFixed(1)
                    : Number(fees).toFixed(1)
                }}</span>
                <span>%</span>
              </artmisads-button>
            </div>
          </div>

          <template v-if="props.type != 'brand' && props.type != 'product'">
            <p class="second-p">
              {{ $t('seller.setPublicCommission.brandReferralBonus') }}
            </p>
            <p class="third-p">
              {{ $t('seller.setPublicCommission.attributionSalesNote') }}
            </p>
          </template>
          <div
            v-if="props.type == 'brand' || props.type == 'product'"
            class="bottom"
          >
            <div class="bottom-title">{{ $t('seller.setPublicCommission.importantNotice') }}</div>
            <div class="bottom-content">
              <div>
                <Icon name="info-tianchong" class="tianchong" />
              </div>
              

              <div>
                <p class="paragraph">
                  {{ $t('seller.setPublicCommission.noticeAttributionIntro') }}
                </p>
                <p class="paragraph" style="margin-top: 10px">
                  {{ $t('seller.setPublicCommission.noticeAttributionFollow') }}
                </p>
                <p class="paragraph" style="padding-left: 10px">
                  <span>· </span
                  ><span class="bold">{{ $t('seller.setPublicCommission.noticeExcludesLead') }}</span>
                  {{ $t('seller.setPublicCommission.noticeExcludesList') }}
                </p>
                <p class="paragraph" style="padding-left: 10px">
                  <span>· </span
                  ><span class="bold">{{ $t('seller.setPublicCommission.noticeIncludesLead') }}</span>
                  {{ $t('seller.setPublicCommission.noticeIncludesList') }}
                </p>
              </div>
            </div>
          </div>
          <div
            v-if="props.type == 'brand' || props.type == 'product'"
            class="bottom"
          >
            <div class="bottom-title">{{ $t('seller.setPublicCommission.effectiveTimePolicy') }}</div>
            <div class="bottom-content">
              <Icon name="info-tianchong" class="tianchong" />

              <div>
                <p class="paragraph">
                  {{ $t('seller.setPublicCommission.effectiveIncrease') }}
                </p>

                <p class="paragraph" style="margin-top: 10px">
                  {{ $t('seller.setPublicCommission.effectiveDecrease') }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template #footer>
        <div class="footerBox">
          <div>
            <div v-if="showTime&&item?.status == 'active'">
              <span class="boldBlack">{{ $t('seller.setPublicCommission.effectiveTimeLabel') }}</span>
              <span class="time">{{ timeYYYY }} 00:00:00</span>
            </div>
          </div>
          <div>
            <artmisads-button class="cancel-btn" @click="onCancel"
              >{{ $t('seller.common.cancel') }}</artmisads-button
            >
            <artmisads-button @click="saveCommission" type="primary"
              >{{ $t('seller.setPublicCommission.saveCommission') }}</artmisads-button
            >
          </div>
        </div>
      </template>
    </artmisads-modal>
  </div>
</template>

<script setup>
import i18n from '~/i18n'

import { message } from 'ant-design-vue'
import Icon from '@/components/Icon.vue'
import { ref, onBeforeMount, computed, onMounted, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { productsApi, brandApi } from '../../../../server/index'
import moment from 'moment'
import { useUserInfoStore } from '@/storeData'
import { COUNTRY_TIME_TZ } from '~/contants/common.js'
import Status from '@/components/Status.vue'

const { t, locale } = useI18n()
const showTime = ref(false)
const initCommission = ref('')
const user = useUserInfoStore()
const timezone = COUNTRY_TIME_TZ[user.userInfo.countryCode]
const showDefalutText = ref(true)
const commissionMinRef = ref(null)
const props = defineProps([
  'type',
  'setSelectSingleProduct',
  'selectSingleProduct',
  'showSetCommission',
  'selectedRowKeys',
  'productList',
  'setShowSetCommission',
  'getProductList',
  'item',
])
const timeYYYY = ref('')
const defaultCommission = ref({
  defaultCommissionRate: 1,
  platformFeeFactor: 1,
  platformMaxFeeRate: 1,
})
const commission = ref('')

const onCancel = () => {
  props.setShowSetCommission(false)
  // props.setSelectSingleProduct('')
  commission.value = ''
}
const modalTitle = computed(() => {
  locale.value
  if (props.type == 'product') {
    if (props?.item?.type == 'single') {
      return t('seller.setPublicCommission.titleSingle')
    }
    const n = props.selectedRowKeys.length || 1
    return n > 1
      ? t('seller.setPublicCommission.titleMultipleMany', { count: n })
      : t('seller.setPublicCommission.titleMultipleOne')
  }
  if (props?.type == 'brand') {
    return t('seller.setPublicCommission.titleBrand')
  }
  if (props?.type == 'product-detail') {
    return t('seller.setPublicCommission.titleSingle')
  }
  return t('seller.setPublicCommission.titleSingle')
})

const feesTooltipText = computed(() => {
  locale.value
  const d = defaultCommission.value
  if (d.platformType === 'multiply') {
    return t('seller.setPublicCommission.feesTooltipMultiply', {
      factor: d.platformFeeFactor,
    })
  }
  return t('seller.setPublicCommission.feesTooltipFixed', {
    factor: d.platformFeeFactor,
  })
})

const handleChangeCommission = (e) => {
  commission.value = e
  if (e) {
    showTime.value = true
    // 
    let nextWorkingDay = moment().tz(timezone)
    let workingDaysCount = 0
    if (commission.value > initCommission.value) {
     while (workingDaysCount < 1) {
      nextWorkingDay = nextWorkingDay.add(1, 'day')
      if (nextWorkingDay.day() !== 0 && nextWorkingDay.day() !== 6) {
        workingDaysCount++
      }
    }
    } else {
     while (workingDaysCount < 4) {
      nextWorkingDay = nextWorkingDay.add(1, 'day')
      if (nextWorkingDay.day() !== 0 && nextWorkingDay.day() !== 6) {
        workingDaysCount++
      }
    }
     
    }
     timeYYYY.value = nextWorkingDay.format('YYYY-MM-DD')
  }
}
const fees = computed(() => {
  let value = 0
  if (defaultCommission.value.platformType === 'multiply') {
    if (commission.value) {
      value =
        (commission.value * defaultCommission.value.platformFeeFactor) / 100
    } else {
      value =
        (defaultCommission.value.defaultCommissionRate *
          defaultCommission.value.platformFeeFactor) /
        100
      if (commission.value == 0) {
        value =
          (commission.value * defaultCommission.value.platformFeeFactor) / 100
      }
    }
  } else {
    value = defaultCommission.value.platformFeeFactor
  }

  if (defaultCommission.value.platformType === 'multiply') {
    if (value >= defaultCommission.value.platformMaxFeeRate) {
      value = defaultCommission.value.platformMaxFeeRate
    }
  } else {
    if (value >= defaultCommission.value.platformFeeFactor) {
      value = defaultCommission.value.platformFeeFactor
    }
  }

  let arr = value && value.toString().split('.')
  let firstNumber = arr && Number(arr[0])
  let middleNum = '0'
  if (arr && arr.length > 1) {
    middleNum = Number(arr[1][0])
    if (arr[1][1] == 5) {
      if (arr[1][0] % 2 !== 0) {
        middleNum += 1
        if (arr[1][0] == 9) {
          middleNum = 0
          firstNumber += 1
        }
      }
    } else if (arr[1][1] > 5) {
      middleNum += 1
      if (arr[1][0] == 9) {
        middleNum = 0
        firstNumber += 1
      }
    }
  }
  let endNum = arr && parseFloat(firstNumber + '.' + middleNum)
  return endNum
})

const setCommissionRef = ref(null)

function commissionBlur(e) {
  const newValue = e.target.value
    .replace(/[^0-9.]/g, '')
    .split('.')
    .map((v, i) => {
      v = v ? parseInt(v) : null

      if (i && v) {
        v = 5
      }

      return v
    })
    .join('.')
  let data = Number(newValue)
  data = data > 99 ? 99 : data
  // 将替换后的字符串转换为数字并赋值给 commission
  commission.value = data
}

const saveCommission = async () => {
  if (
    props.type == 'product' ||
    props.type == 'product-detail' ||
    props.type == 'brand-detail' ||
    props.type == 'brand-detail-multiple'
  ) {
    const params = {
      commissionRate: commission.value,
      ids: props.selectSingleProduct
        ? [props.selectSingleProduct]
        : props.selectedRowKeys,
      platformFeeRate: fees.value,
    }
    const res = await productsApi.setCommission(params)
    const { success, error } = res
    if (success) {
      onCancel()
      message.success(i18n.global.t('seller.msg.success'))
      if (props.type == 'product') {
        props.getProductList()
      } else if (props.type == 'brand-detail') {
        props.getProductList(params.commissionRate)
      } else if (props.type == 'brand-detail-multiple') {
        props.getProductList()
      } else {
        props.getProductList(params.ids)
      }
    }
  }
  if (props.type == 'brand') {
    let req = {
      id: props.selectSingleProduct,
      commissionRate: commission.value,
    }
    brandApi.setBrandPer(req).then((res) => {
      if (res.success) {
        onCancel()
        props.getProductList()
        message.success(i18n.global.t('seller.msg.success'), 1)
      }
    })
  }
}

const clickDefalutText = () => {
  showDefalutText.value = false
  commissionMinRef.value.focus()
}

const getRate = async () => {
  const res = await productsApi.getCommissionConfig({
    commissionType: 'attribution',
  })

  const { success, data, error } = res
  if (success) {
    defaultCommission.value = data
  }
}

const setDefaultCommission = () => {
  const selectedRowKeysLength = props.selectedRowKeys.length

  if (selectedRowKeysLength === 1) {
    commission.value = props.productList.find(
      (item) => item.id === props.selectedRowKeys[0],
    )?.commission|| 0
  } else if (selectedRowKeysLength > 1) {
    commission.value = defaultCommission.value.defaultCommissionRate
  }
  if (props.selectSingleProduct) {
    if (props.type == 'product-detail') {
      console.log(props.productList?.currentCommissionVO,'props.productList?.currentCommissionVO')
      if(props.productList?.currentCommissionVO){
        if(Object.keys(props.productList?.currentCommissionVO)?.length){
      commission.value = props.productList?.currentCommissionVO?.commission || 0
    }else{
      commission.value = props.productList?.commission || 0
    }
      }
      else{
         commission.value = props.productList?.commission || 0
      }
     } else {
      commission.value = props.productList.find(
        (item) => item.id === props.selectSingleProduct,
      ).commission
    }
  }
  initCommission.value = commission.value
}

watch(props, () => {
  setDefaultCommission()
  showTime.value = false
},{deep:true})

onBeforeMount(() => {
  getRate()
})
</script>

<style lang="less" scoped>
.bottom {
  margin-top: 42px;
}

.tianchong {
  color: rgba(131, 92, 242, 1);
font-size: 16px;
margin-top: 2px;
}
.topMulti {
  padding: 24px;
  font-family: Sora;
  font-weight: 500;
  font-style: Medium;
  font-size: 16px;
  color: rgba(15, 6, 41, 0.5);
  .boldBlack {
    font-family: Sora;
    font-weight: 600;
    font-style: SemiBold;
    font-size: 16px;
    color: rgba(15, 6, 41, 0.9);
  }
}

.title {
  font-family: Sora;
  font-weight: 600;
  font-size: 16px;
  color: rgba(15, 6, 41, 1);
  margin: 6px 0;
}
.cancel-btn {
  border: none;
  background-color: var(--bg-gray-6);

  &:hover {
    background-color: var(--bg-gray-4);
  }
}

.footerBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100% !important;
  .boldBlack {
    font-family: Sora;
    font-weight: 400;
    font-style: Regular;
    font-size: 13px;
    color: rgba(15, 6, 41, 0.7);
  }
  .time {
    font-family: Sora;
    font-weight: 500;
    font-size: 13px;
    color: rgba(15, 6, 41, 1);
  }
}
.bottom-title {
  font-family: Sora;
  font-weight: 500;
  font-size: 13px;
  color: rgba(15, 6, 41, 1);
  margin-bottom: 12px;
}

.paragraphContent {
  font-family: Sora;
  font-weight: 700;
  font-style: Bold;
  font-size: 13px;
}

.paragraph {
  font-family: Sora;
  font-weight: 400;
  font-style: Regular;
  font-size: 13px;
}

.bold {
  font-family: Sora;
  font-weight: 700;
  font-style: Bold;
  font-size: 13px;
    color: rgba(15, 6, 41, 0.9);
}

.bottom-content {
  border-radius: 8px;
  background-color: rgba(80, 64, 128, 0.08);
  padding: 10px;
  display: flex;
  gap: 10px;
}



.brand-img-show {
  width: 56px;
  height: 56px;
  display: flex;
  border-radius: 8px;
  align-items: center;
  background: var(--bg-gray-2);

  img {
    border-radius: 8px;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .brand-name {
    margin: 0 auto;
    padding: 0 4px;
    max-width: 56px;
    font-size: 11px;
    overflow: hidden;
    max-height: 39px;
    font-weight: 600;
    line-height: 13px;
    text-align: center;
    color: var(--dark-4);
    letter-spacing: 0.3px;
  }
}

.top {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 24px 24px 0 24px;
  margin-bottom: 32px;
  .top-left {
  }

  .wenhao {
    fill: var(--dark-4);
  }

  .top-right {
    flex: 1;
    width: 86%;

    .top-right-title {
      font-family: Sora;
      font-weight: 500;
      font-style: Medium;
      font-size: 15px;
      margin-bottom: 16px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .top-right-content {
      display: flex;
      align-items: center;
      width: 100%;

      > div {
        display: flex;
        align-items: center;
        min-width: 0;
      }

      .top-right-status-title {
        font-family: Sora;
        font-weight: 500;
        font-style: Medium;
        font-size: 14px;
        color: rgba(135, 130, 148, 1);
        white-space: nowrap;
      }

      .top-right-status-count {
        font-family: Sora;
        font-weight: 500;
        font-size: 12px;
        line-height: 20px;
        margin-left: 4px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .top-right-status {
        display: flex;
        align-items: center;
        min-width: 0;
      }

      .top-right-mid {
        max-width: 2px;
        min-width: 2px;
        height: 10px;
        opacity: 1;
        background-color: rgba(232, 229, 237, 1);
        margin: 0 10px;
        flex-shrink: 0;
      }
    }

    .top-right-products {
      display: flex;
      align-items: center;
      min-width: 0;
    }
  }
}

.set-commission {
  :deep(.ant-modal) {
    .ant-modal-body {
      padding: 0;
      border: none;
    }
  }

  :deep(.ant-tooltip) {
    &-inner {
      width: 260px;
      font-size: 12px;
      white-space: nowrap;
    }
  }

  .set-commission-wrap {
    p {
      font-family: Sora, sans-serif;
    }

    .first-p {
      padding: 24px 17px 24px 24px;
      color: var(--dark-3);
      font-weight: 400;
      line-height: 22px;
    }

    .third-p {
      margin-top: 28px;
      background: var(--big-bg-2);
      border-radius: 8px;
      padding: 8px 12px;
      font-size: var(--font-size-min);
      color: var(--dark-3);
      letter-spacing: 0.2px;
      line-height: 18px;
    }

    .second-p {
      font-size: var(--font-size-min);
      align-self: end;
      padding: 8px 12px;
      margin-top: 15px;
      width: 286px;
      background: var(--color-white);
      border: 1px solid var(--border-4);
      box-shadow: var(--section-box-shadow-2);
      border-radius: 8px;
      color: var(--dark-3);
      letter-spacing: 0.2px;
      line-height: 16px;
      position: relative;
      font-style: italic;

      &::before {
        content: '';
        position: absolute;
        top: -5px;
        right: 130px;
        width: 8px;
        height: 8px;
        border: 1px solid var(--border-1);
        border-color: var(--border-4) transparent transparent var(--border-4);
        background-color: #ffffff;
        transform: rotate(45deg);
      }
    }
  }

  .content {
    display: flex;
    flex-direction: column;
    padding: 0 24px 24px 24px;

    .commission {
      display: flex;

      > span {
        align-self: center;
        margin: 20px 10px 0 10px;
        font-family: Sora, sans-serif;
        font-weight: 500;
        color: #0f0629;
      }

      .fees,
      .total,
      .commission-input {
        display: flex;
        flex-direction: column;

        > span {
          margin-bottom: 6px;
          font-weight: 500;
          color: var(--dark-2);
          line-height: 19px;
        }
      }

      .commission-input {
        position: relative;

        .defalut-text {
          position: absolute;
          font-family: Sora, sans-serif;
          color: var(--dark-4);
          line-height: 20px;
          left: 15px;
          top: 34px;
          margin: 0;
        }

        .haifenhao {
          position: absolute;
          font-weight: 500;
          font-size: var(--font-size-large);
          color: var(--dark-1);
          right: 30px;
          top: 34px;
          margin: 0;
        }

        :deep(.ant-input-number) {
          width: 200px;

          .ant-input-number-handler-wrap {
            opacity: 1;
          }
        }
      }

      .total {
        > button {
          width: 96px;
          display: flex;
          justify-content: space-between;

          > span {
            align-self: center;
          }
        }
      }

      .fees {
        > button {
          width: 144px;
        }

        .question-icon {
          margin-left: 3px;
          color: var(--yellow-4);
        }
      }

      .fees,
      .total {
        > button {
          padding-left: 12px;
          text-align: left;
          border-radius: 8px;
          font-weight: 500;
          font-size: var(--font-size-large);
          color: var(--dark-1);
        }
      }
    }
  }
}
</style>
